import { render, staticRenderFns } from "./SearchNavItemKeyword.vue?vue&type=template&id=0d67df26&scoped=true&"
import script from "./SearchNavItemKeyword.vue?vue&type=script&lang=js&"
export * from "./SearchNavItemKeyword.vue?vue&type=script&lang=js&"
import style0 from "./SearchNavItemKeyword.vue?vue&type=style&index=0&id=0d67df26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d67df26",
  null
  
)

export default component.exports